import * as z from "zod";
import { aeoDateRangeInput } from "./types";

const visibilityDataPoint_ = z.object({
  date: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/, {
      message: "Date must be in YYYY-MM-DD format",
    })
    .describe(
      "Date in YYYY-MM-DD format (week start date for weekly granularity)",
    ),
  mentions: z
    .number()
    .int()
    .min(0)
    .nullable()
    .describe("Total brand mentions, null if no data"),
  shareOfVoice: z
    .number()
    .min(0)
    .max(100)
    .nullable()
    .describe("Share of voice percentage (0-100), null if no data"),
  brandVisibility: z
    .number()
    .min(0)
    .max(100)
    .nullable()
    .describe(
      "Brand visibility percentage (mentions / total prompts * 100), null if no data",
    ),
  totalPrompts: z
    .number()
    .int()
    .min(0)
    .nullable()
    .describe("Total prompts tracked for this period, null if no data"),
});
export const visibilityDataPoint: z.ZodType<VisibilityDataPoint> =
  visibilityDataPoint_;
export interface VisibilityDataPoint extends z.infer<
  typeof visibilityDataPoint_
> {}

export const getBrandVisibilityOverTime = {
  name: "getBrandVisibilityOverTime" as const,
  input: aeoDateRangeInput,
  output: z.object({
    dataPoints: z.array(visibilityDataPoint),
    granularity: z.enum(["daily", "weekly"]),
  }),
};
